export default "__VITE_ASSET__1d156b5a__"